import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugAzathioprine} from "./TextDrugAzathioprine"


export default function Azathioprine() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
 
    <ButtonsText onClick={handleOpen} name='Azathioprine' size='large' color='common.white'   />
    <CustomDialog open={open} onClose={handleClose}

        title="Azathioprine - PGx Recommendation"
        content={ <TextDrugAzathioprine />}

        />

</>
)}